module.exports = __webpack_public_path__ + "static/media/radio-on.64bcfb32.svg";